<mat-paginator
  [hidePageSize]="true"
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  (page)="onPageChange($event)">
</mat-paginator>
